import * as React from "react";
import { cva } from "class-variance-authority";
import { customTwMerge } from "utils";
import PropTypes from "prop-types";

const badgeVariants = cva(
  "tw-inline-flex tw-items-center tw-capitalize tw-rounded-[16px] tw-whitespace-nowrap tw-border tw-px-[8px] tw-py-[2px] tw-text-[12px] " +
    "tw-font-medium tw-transition-colors tw-cursor-pointer focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2",
  {
    variants: {
      variant: {
        default: "tw-border-transparent tw-bg-primary-50 tw-text-primary-600",
        secondary:
          "tw-border-transparent tw-bg-[#EBFAFF] tw-text-[#2498CE] hover:tw-bg-[#EBFAFF]/80 hover:tw-text-white",
        success: "tw-border-transparent tw-text-[#1D3B32] tw-bg-[#C4EFDF]",
        destructive:
          "tw-border-transparent tw-bg-destructive-100 tw-text-destructive-700 hover:tw-bg-destructive/80 hover:tw-text-white",
        outline: "tw-text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

/** @param {Record<string, unknown>} props */
function Badge({ className, variant, ...props }) {
  return <div className={customTwMerge(badgeVariants({ variant }), className)} {...props} />;
}

Badge.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
};

export { Badge, badgeVariants };
